module.exports = __webpack_public_path__ + "9e61afea698a88f7e3c460a8c7f0d074.svg";